import { registerApplication, start } from 'single-spa';
import {
  constructApplications,
  constructRoutes,
  constructLayoutEngine,
} from 'single-spa-layout';

import { ConfigModule } from '@built/config-utility';
import { initializeUserPilot } from './initUserPilot';

const routes = constructRoutes(
  document.querySelector('#single-spa-layout') as HTMLTemplateElement
);
const applications = constructApplications({
  routes,
  loadApp({ name }) {
    return System.import(name);
  },
});
const layoutEngine = constructLayoutEngine({ routes, applications });

const initOrchestrator = async () => {
  try {
    await ConfigModule.loadConfig();
    applications.forEach(registerApplication);
    layoutEngine.activate();

    initializeUserPilot();
  } catch (error) {
    console.error('Error initializing config: ', error);
    return Promise.resolve();
  }
};

initOrchestrator().then(() => start());
